import React, { useEffect, useState, useRef } from 'react';
import { Form, Input, Select, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import RichTextEditor from '../../components/RichTextEditor'; // ปรับ path ให้ตรง

const NewsForm = () => {
    const quillRef = useRef();
    const [form] = Form.useForm();
    const [categories, setCategories] = useState([]);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/news-categories`).then((res) => setCategories(res.data));

        if (id) {
            axios.get(`${API_BASE_URL}/api/news/${id}`).then((res) => {
                form.setFieldsValue(res.data);
            });
        }
    }, [id, form]);

    const extractFirstImage = (htmlContent) => {
        const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
        const img = doc.querySelector('img');
        return img ? img.src : null;
    };


    const onFinish = async (values) => {
        const user = JSON.parse(localStorage.getItem('user'));
        values.author_id = user.id
        values.author = user.name

        // 👇 ดึงรูปแรกมาเก็บไว้ในฟิลด์ cover_image
        const firstImage = extractFirstImage(values.content);
        if (firstImage) {
            values.cover_image = firstImage;
        } else {
            values.cover_image = '';
        }

        try {
            if (id) {
                await axios.put(`${API_BASE_URL}/api/news/${id}`, values);
                message.success('อัปเดตข่าวเรียบร้อย');
            } else {
                await axios.post(`${API_BASE_URL}/api/news`, values);
                message.success('สร้างข่าวเรียบร้อย');
            }
            navigate('/news-managments');
        } catch {
            message.error('ไม่สามารถบันทึกข่าวได้');
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item>
                <Button type="primary" htmlType="submit" style={{float: 'right', }}>
                    {id ? 'อัปเดตข่าว' : 'สร้างข่าว'}
                </Button>
            </Form.Item>
            <Form.Item name="title" label="หัวข้อข่าว" rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name="category_id" label="หมวดหมู่" rules={[{ required: true }]}>
                <Select options={categories.map((c) => ({ value: c.id, label: c.name }))} />
            </Form.Item>

            <Form.Item name="content" label="เนื้อหาข่าว" rules={[{ required: true }]} style={{ padding: '10px' }}>
                <RichTextEditor
                    value={form.getFieldValue('content')}
                    onChange={(value) => form.setFieldsValue({ content: value })}
                />
            </Form.Item>
        </Form>
    );
};

export default NewsForm;